//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchQuery: '',
    }
  },
  mounted() {
    if (this.isModal) this.focusInput()
    document.addEventListener('mousedown', this.handleClickOutside)
  },
  beforeDestroy() {
    if (this.isModal)
      document.removeEventListener('mousedown', this.handleClickOutside)
  },
  methods: {
    search() {
      if (this.searchQuery.trim()) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        this.$router.push({ path: '/search', query: { q: this.searchQuery } })
        this.searchQuery = ''
        if (this.isModal) {
          this.closeDialog()
        }
      }
    },
    closeDialog() {
      this.$store.commit('global/setDialog', {
        dialog: null,
        layer: false,
      })
    },
    handleClickOutside(event) {
      if (
        this.$refs.dialogSearch &&
        !this.$refs.dialogSearch.contains(event.target)
      ) {
        this.closeDialog()
      }
    },
    focusInput() {
      this.$nextTick(() => {
        if (this.$refs.searchInput) {
          this.$refs.searchInput.focus()
        }
      })
    },
  },
}
